<template>
  <div class="avatar-container">
    <div
      :class="{
        'avatar': true,
        [`avatar-${rank}`]: true,
      }"
    >
      <img
        class="avatar-icon"
        :src="current"
      >
      <img
        class="avatar-img"
        :src="src"
      >
    </div>

    <div class="avatar-name">{{ name }}</div>
  </div>
</template>

<script>
import rank1 from '@/assets/image/direct/rank-1.png';
import rank2 from '@/assets/image/direct/rank-2.png';
import rank3 from '@/assets/image/direct/rank-3.png';

export default {
  props: {
    rank: {
      type: Number,
      required: true,
    },

    src: {
      type: String,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },
  },

  computed: {
    current() {
      if (this.rank === 1) {
        return rank1;
      } else if (this.rank === 2) {
        return rank2;
      } else if (this.rank === 3) {
        return rank3;
      }
      return '';
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  &-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  width: 70px;
  height: 70px;
  border-radius: 50%;
  border-width: 2px;
  border-style: solid;
  position: relative;

  &-1 {
    border-color: #ffe222;
  }

  &-2 {
    border-color: #dadde2;
  }

  &-3 {
    border-color: #e7c9a6;
  }

  &-icon {
    width: 26px;
    height: 19px;
    position: absolute;
    left: 50%;
    margin-left: -13px;
    top: -12px;
  }

  &-img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  &-name {
    font-size: 14px;
    font-weight: 500;
    color: rgba(48, 49, 51, 1);
    line-height: 14px;
    margin-top: 6px;
  }
}
</style>